import React from 'react';
import { Link } from 'react-router-dom';
import
    { Slider
    , FormGroup
    , Breadcrumbs
} from '@germix/germix-react-core';
import { withTranslation, WithTranslation } from 'react-i18next';

import Application from '../components/app/Application';
import d2h from '../utils/d2h';
import copyToClipboard from '../utils/copyToClipboard';

interface Props extends WithTranslation
{
}
interface State
{
    gray,
    red,
    green,
    blue,
}

/**
 * @author Germán Martínez
 */
class RouteToolsColorPicker extends React.Component<Props,State>
{
    state: State =
    {
        gray: 0,
        red: 0,
        green: 0,
        blue: 0,
    }
    render()
    {
        const { t } = this.props;

        return (
<Application>
    <FormGroup>
        <Breadcrumbs>
            <Link to='/'>{t('titles.home')}</Link>
            <Link to='/tools'>{t('titles.tools')}</Link>
            <Link to='/tools/color-picker'>{t('titles.toolsColorPicker')}</Link>
        </Breadcrumbs>
        <br/>
    </FormGroup>
    <FormGroup>
        <h1>{t('titles.toolsColorPicker')}</h1>
    </FormGroup>
    <FormGroup>
        <div className="row">
            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolColorPicker.redLabel')}</label>
                        <label className="ml-auto">{this.state.red}</label>
                    </div>
                    <Slider
                        min={0}
                        max={255}
                        value={this.state.red}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            red: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolColorPicker.greenLabel')}</label>
                        <label className="ml-auto">{this.state.green}</label>
                    </div>
                    <Slider
                        min={0}
                        max={255}
                        value={this.state.green}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            green: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolColorPicker.blueLabel')}</label>
                        <label className="ml-auto">{this.state.blue}</label>
                    </div>
                    <Slider
                        min={0}
                        max={255}
                        value={this.state.blue}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            blue: newValue
                        });
                    }}/>
                </FormGroup>
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <label>{ t('toolColorPicker.grayLabel')}</label>
                        <label className="ml-auto">{this.state.gray}</label>
                    </div>
                    <Slider
                        min={0}
                        max={255}
                        value={this.state.gray}
                        onChange={(newValue) =>
                    {
                        this.setState({
                            gray: newValue,
                            red: newValue,
                            green: newValue,
                            blue: newValue,
                        });
                    }}/>
                </FormGroup>
            </div>

            <div className="col">
                <FormGroup>
                    <div style={{display: 'flex'}}>
                        <input className="form-control" value={this.getColorHTML()} readOnly={true} />
                        <span className="mini-button ml-1" onClick={() =>
                        {
                            copyToClipboard(this.getColorHTML());
                        }}>
                            <i className="icon-clipboard"></i>
                        </span>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div style={{
                        background: this.getColorHTML(),
                        width: '100%',
                        height: '200px',
                        border: '2px solid black',
                        borderRadius: '4px',
                    }}>
                    </div>
                </FormGroup>
            </div>
        </div>
    </FormGroup>
</Application>
        );
    }

    private getColorHTML()
    {
        return '#' + d2h(this.state.red) + d2h(this.state.green) + d2h(this.state.blue);
    }
}
export default withTranslation('common')(RouteToolsColorPicker);
